var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPageNotFound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 400 312",
    width: 400,
    height: 312,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M35.07 35.07C36.16 33.98 36.79 32.46 36.79 30.92C36.79 29.37 36.16 27.86 35.07 26.77C33.98 25.68 32.46 25.05 30.92 25.05C29.38 25.05 27.86 25.68 26.77 26.77C25.68 27.86 25.05 29.38 25.05 30.92C25.05 32.46 25.68 33.98 26.77 35.07C27.86 36.16 29.37 36.79 30.92 36.79C32.46 36.79 33.98 36.16 35.07 35.07Z",
    id: "d4yb08ojWV"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.86 35.07C54.95 33.98 55.58 32.46 55.58 30.92C55.58 29.38 54.95 27.86 53.86 26.77C52.77 25.68 51.25 25.05 49.71 25.05C48.16 25.05 46.65 25.68 45.56 26.77C44.46 27.86 43.84 29.38 43.84 30.92C43.84 32.46 44.46 33.98 45.56 35.07C46.65 36.16 48.16 36.79 49.71 36.79C51.25 36.79 52.77 36.16 53.86 35.07Z",
    id: "bef6W5th5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.64 35.07C73.74 33.98 74.36 32.46 74.36 30.92C74.36 29.38 73.74 27.86 72.64 26.77C71.55 25.68 70.04 25.05 68.49 25.05C66.95 25.05 65.43 25.68 64.34 26.77C63.25 27.86 62.62 29.38 62.62 30.92C62.62 32.46 63.25 33.98 64.34 35.07C65.43 36.16 66.95 36.79 68.49 36.79C70.04 36.79 71.55 36.16 72.64 35.07Z",
    id: "avDRBq9fx"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.51 36.79C334.75 36.79 337.38 34.16 337.38 30.92C337.38 27.68 334.75 25.05 331.51 25.05C307.71 25.05 117.34 25.05 93.54 25.05C90.3 25.05 87.67 27.68 87.67 30.92C87.67 34.16 90.3 36.79 93.54 36.79C141.14 36.79 307.71 36.79 331.51 36.79Z",
    id: "bDxKCthe4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.08 36.79C372.32 36.79 374.95 34.16 374.95 30.92C374.95 27.68 372.32 25.05 369.08 25.05C367.83 25.05 357.81 25.05 356.56 25.05C353.32 25.05 350.68 27.68 350.68 30.92C350.68 34.16 353.32 36.79 356.56 36.79C359.06 36.79 367.83 36.79 369.08 36.79Z",
    id: "b4ancop4g"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.92 193.74C230.92 207.34 219.86 218.4 206.26 218.4C205.01 218.4 194.99 218.4 193.74 218.4C180.14 218.4 169.08 207.34 169.08 193.74C169.08 189.98 169.08 159.92 169.08 156.17C169.08 142.57 180.14 131.51 193.74 131.51C194.99 131.51 205.01 131.51 206.26 131.51C219.86 131.51 230.92 142.57 230.92 156.17C230.92 163.68 230.92 189.98 230.92 193.74ZM206.26 143.25C205.01 143.25 194.99 143.25 193.74 143.25C186.61 143.25 180.82 149.04 180.82 156.17C180.82 159.92 180.82 189.98 180.82 193.74C180.82 200.86 186.61 206.65 193.74 206.65C194.99 206.65 205.01 206.65 206.26 206.65C213.39 206.65 219.18 200.86 219.18 193.74C219.18 191.23 219.18 178.71 219.18 156.17C215.32 147.55 211.01 143.25 206.26 143.25Z",
    id: "bH4u7qcgK"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.51 187.87C149.51 157.57 149.51 140.74 149.51 137.38C149.51 134.14 146.88 131.51 143.64 131.51C140.4 131.51 137.77 134.14 137.77 137.38C137.77 140.74 137.77 157.57 137.77 187.87L107.95 187.87C117.68 158.69 123.08 142.48 124.16 139.23C125.19 136.16 123.52 132.84 120.45 131.81C117.37 130.78 114.04 132.45 113.02 135.52C111.14 141.16 96.11 186.25 94.23 191.88C93.64 193.68 93.94 195.64 95.05 197.17C96.15 198.7 97.92 199.61 99.8 199.61C102.34 199.61 114.99 199.61 137.77 199.61C137.77 207.36 137.77 211.66 137.77 212.53C137.77 215.77 140.4 218.4 143.64 218.4C146.88 218.4 149.51 215.77 149.51 212.53C149.51 211.66 149.51 207.36 149.51 199.61C153.5 199.61 155.72 199.61 156.16 199.61C159.41 199.61 162.04 196.98 162.04 193.74C162.04 190.5 159.41 187.87 156.16 187.87C155.28 187.87 153.06 187.87 149.51 187.87Z",
    id: "e37GdM3C9q"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.54 187.87C293.54 157.57 293.54 140.74 293.54 137.38C293.54 134.14 290.91 131.51 287.67 131.51C284.43 131.51 281.8 134.14 281.8 137.38C281.8 140.74 281.8 157.57 281.8 187.87L251.98 187.87C261.71 158.69 267.11 142.48 268.2 139.23C269.22 136.16 267.55 132.84 264.48 131.81C261.4 130.78 258.07 132.45 257.05 135.52C255.17 141.16 240.14 186.25 238.26 191.88C237.67 193.68 237.96 195.64 239.07 197.17C240.17 198.7 241.95 199.61 243.84 199.61C246.37 199.61 259.02 199.61 281.8 199.61C281.8 207.36 281.8 211.66 281.8 212.53C281.8 215.77 284.43 218.4 287.67 218.4C290.91 218.4 293.54 215.77 293.54 212.53C293.54 211.66 293.54 207.36 293.54 199.61C297.53 199.61 299.75 199.61 300.2 199.61C303.44 199.61 306.07 196.98 306.07 193.74C306.07 190.5 303.44 187.87 300.2 187.87C299.31 187.87 297.09 187.87 293.54 187.87Z",
    id: "b3ipEFkOOh"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 281.11C400 298.14 386.13 312 369.08 312C335.26 312 64.74 312 30.92 312C13.87 312 0 298.14 0 281.11C0 256.09 0 55.91 0 30.89C0 13.86 13.87 0 30.92 0C64.74 0 335.26 0 369.08 0C386.13 0 400 13.86 400 30.89C400 80.93 400 256.09 400 281.11ZM11.74 50.05L388.26 50.05C388.26 38.55 388.26 32.16 388.26 30.89C388.26 20.32 379.66 11.73 369.08 11.73C335.26 11.73 64.74 11.73 30.92 11.73C20.34 11.73 11.74 20.32 11.74 30.89C11.74 33.44 11.74 39.83 11.74 50.05ZM388.26 61.77L11.74 61.77C11.74 193.38 11.74 266.49 11.74 281.11C11.74 291.68 20.34 300.27 30.92 300.27C64.74 300.27 335.26 300.27 369.08 300.27C379.66 300.27 388.26 291.68 388.26 281.11C388.26 251.87 388.26 178.75 388.26 61.77Z",
    id: "b3gUN0Pb4E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d4yb08ojWV",
    opacity: 1,
    fill: "#999999",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d4yb08ojWV",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bef6W5th5",
    opacity: 1,
    fill: "#999999",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bef6W5th5",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#avDRBq9fx",
    opacity: 1,
    fill: "#999999",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#avDRBq9fx",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bDxKCthe4",
    opacity: 1,
    fill: "#999999",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bDxKCthe4",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b4ancop4g",
    opacity: 1,
    fill: "#999999",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b4ancop4g",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bH4u7qcgK",
    opacity: 1,
    fill: "#999999",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bH4u7qcgK",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e37GdM3C9q",
    opacity: 1,
    fill: "#999999",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e37GdM3C9q",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b3ipEFkOOh",
    opacity: 1,
    fill: "#999999",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b3ipEFkOOh",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b3gUN0Pb4E",
    opacity: 1,
    fill: "#999999",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b3gUN0Pb4E",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageNotFound);
export default __webpack_public_path__ + "static/media/page_not_found.18a67ee3.svg";
export { ForwardRef as ReactComponent };